import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { FiInstagram, FiFacebook, FiTwitter } from "react-icons/fi";
import { FaTiktok } from "react-icons/fa";
import { SiGoodreads } from "react-icons/si";
import SEO from "../components/SEO";

export default function About({ generalConfig }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const authorName = generalConfig?.authorName || "Liliz Black";

    useEffect(() => {
        async function load() {
            try {
                const snap = await getDoc(doc(db, "siteConfig", "about"));
                if (snap.exists()) setData(snap.data());
            } catch (e) {
                console.error("Error loading about page:", e);
            }
            setLoading(false);
        }
        load();
    }, []);

    if (loading) return (
        <div className="container" style={{ padding: "100px 20px", textAlign: "center", color: "#888" }}>
            Loading about page...
        </div>
    );

    const configData = data || {};

    return (
        <div className="about-page">
            <SEO pageId="about" />
            <div className="container" style={{ padding: "80px 20px" }}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 60, alignItems: "center" }}>
                    
                    {/* Photo Side */}
                    <div style={{ flex: "1 1 400px", maxWidth: 500 }}>
                        <div style={{ position: "relative" }}>
                            <div style={{ position: "absolute", top: 20, left: 20, width: "100%", height: "100%", border: "2px solid var(--accent)", borderRadius: 16, zIndex: 0 }}></div>
                            <img 
                                src={configData.photoUrl || "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=800"} 
                                alt="Author" 
                                style={{ width: "100%", borderRadius: 16, position: "relative", zIndex: 1, boxShadow: "0 10px 30px rgba(0,0,0,0.1)" }}
                            />
                        </div>
                    </div>

                    {/* Text Side */}
                    <div style={{ flex: "1 1 500px" }}>
                        <span style={{ color: "var(--accent)", fontWeight: 700, textTransform: "uppercase", letterSpacing: 2, fontSize: 14, display: "block", marginBottom: 12 }}>The Author</span>
                        <h1 style={{ fontSize: "3.5rem", fontFamily: "'Playfair Display', serif", marginBottom: 24, color: "var(--green-primary)" }}>
                            {configData.heading || `About ${authorName}`}
                        </h1>
                        <div 
                            style={{ fontSize: "1.1rem", lineHeight: 1.8, color: "#555", marginBottom: 32 }}
                            dangerouslySetInnerHTML={{ 
                                __html: configData.bio || `${authorName} is an author of bold stories for bold readers.` 
                            }}
                        />

                        <div style={{ display: "flex", gap: 20 }}>
                            {configData.instagram && (
                                <a href={configData.instagram} target="_blank" rel="noreferrer" className="social-link-about">
                                    <FiInstagram size={24} />
                                </a>
                            )}
                            {configData.facebook && (
                                <a href={configData.facebook} target="_blank" rel="noreferrer" className="social-link-about">
                                    <FiFacebook size={24} />
                                </a>
                            )}
                            {configData.tiktok && (
                                <a href={configData.tiktok} target="_blank" rel="noreferrer" className="social-link-about">
                                    <FaTiktok size={22} />
                                </a>
                            )}
                            {configData.goodreads && (
                                <a href={configData.goodreads} target="_blank" rel="noreferrer" className="social-link-about">
                                    <SiGoodreads size={20} />
                                </a>
                            )}
                        </div>
                    </div>

                </div>
            </div>

            <style>{`
                .social-link-about {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    background: #f4f1ea;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--green-primary);
                    transition: all 0.3s;
                }
                .social-link-about:hover {
                    background: var(--green-primary);
                    color: white;
                    transform: translateY(-3px);
                }
            `}</style>
        </div>
    );
}
